import { connect } from 'react-redux'
import ContentWithNavigationSidebar from './ContentWithNavigationSidebar'

const mapActionCreators = {
}

const mapStateToProps = state => ({
  sidebarIsCollapsed: state.app.sidebarIsCollapsed,
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(ContentWithNavigationSidebar)



// WEBPACK FOOTER //
// ./src/legacy/layouts/ContentWithNavigationSidebar/container.jsx